// Validate Solana address using base58 validation
export const isSolanaAddress = (address: string): boolean => {
  // Solana addresses are 32 bytes encoded in base58, resulting in 44 characters
  if (address.length !== 44) {
    return false;
  }

  // Basic base58 character validation
  const base58Regex = /^[1-9A-HJ-NP-Za-km-z]+$/;
  if (!base58Regex.test(address)) {
    return false;
  }

  // Additional validation could be added here using a base58 library
  // For now, we'll do basic format validation
  return true;
};
